export default "__VITE_ASSET__DpB1GZq7__"